import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage, AppLanguage, SUPPORTED_LANGUAGES } from '../../i18n';

type LanguageSwitcherProps = {
  className?: string;
  compact?: boolean;
  /** Empilha bandeiras na vertical (ideal ao lado do formulário no desktop) */
  orientation?: 'horizontal' | 'vertical';
  /** Estilo destacado para fundos escuros / painel flutuante */
  variant?: 'default' | 'floating';
};

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  className = '',
  compact = false,
  orientation = 'horizontal',
  variant = 'default'
}) => {
  const { i18n } = useTranslation();
  const current = (i18n.language?.split('-')[0] || 'pt') as AppLanguage;

  const setLanguage = (lng: AppLanguage) => {
    if (lng === current) return;
    document.documentElement.lang = lng === 'pt' ? 'pt-BR' : lng;
    void changeLanguage(lng);
  };

  const groupLabel =
    current === 'en'
      ? 'Select language'
      : current === 'es'
        ? 'Seleccionar idioma'
        : 'Selecionar idioma';

  const orientationClass =
    orientation === 'vertical' ? 'lang-switcher--vertical flex-col' : 'inline-flex items-center';
  const variantClass =
    variant === 'floating'
      ? 'lang-switcher--floating border-white/30 bg-white/95 backdrop-blur-md shadow-lg'
      : 'border-gray-200/90 bg-gradient-to-b from-gray-50 to-white shadow-sm';

  return (
    <div
      role="group"
      aria-label={groupLabel}
      className={`lang-switcher ${orientationClass} gap-1 rounded-xl border p-1 ${variantClass} ${className}`}
    >
      {SUPPORTED_LANGUAGES.map((lang) => {
        const isActive = current === lang.code;
        return (
          <button
            key={lang.code}
            type="button"
            onClick={() => setLanguage(lang.code)}
            aria-label={lang.label}
            aria-pressed={isActive}
            title={lang.label}
            className={`lang-switcher__btn ${compact ? 'lang-switcher__btn--compact' : ''} ${
              isActive ? 'lang-switcher__btn--active' : ''
            }`}
          >
            <span className="lang-switcher__flag" aria-hidden>
              {lang.flag}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
